<template>
  <div class="select-pay">
    <iHeader />
    <iNav :search="false" :car-btn="false" :phone="false" :title="false" content>
      <div slot="content" class="carName">
        <div class="cn">收银台</div>
        <img style="width: 396px;" src="../../assets/buycar/step2.png">
      </div>
    </iNav>
    <div v-if="!loading">
      <div class="orderInfo">
        <img width="47" height="48" src="../../assets/buycar/com.png">
        <div class="infotext">
          <div class="info">
            <div class="line1">
              订单已生成！
              <span>请尽快完成支付。</span>
            </div>
            <!-- <div class="line2">
              请在

              <span v-if="OffTime">9分</span>
              内完成支付, 超时后将取消订单。
            </div> -->
          </div>
          <div v-if="payOrderInfo && payOrderInfo.Price" class="price">
            应付金额：
            <span>￥{{ payOrderInfo.Price ||'' }}</span>
          </div>
        </div>
      </div>

      <div class="payInfo">
        <div class="tip">
          <span>选择以下支付方式付款</span>
          <span style="cursor: pointer;">
            <router-link
              target="_blank"
              :to="{ name: LinkTypeCode.HelpCenter, query: { activedParentKey: 3, activedKey: 32, Id: '164e7169-71a6-45e6-5079-08d811cf9ba3' } }"
            >
              支付遇到问题？
            </router-link>
          </span>
        </div>
        <div class="line" />
        <!-- 第三方支付 -->
        <div class="three">
          <div

            class="alipay"
            :class="{ checked: payWay == 'alipay' }"
            @click.stop="onChangePayWay('alipay')"
          >
            <img src="../../assets/buycar/alipay.png">
            <div class="check"><img style="left: 0;" src="../../assets/buycar/checked.png"></div>
          </div>
          <div

            class="wxpay"
            :class="{ checked: payWay == 'wxpay' }"
            @click.stop="onChangePayWay('wxpay')"
          >
            <img src="../../assets/buycar/wxpay.png">
            <div class="check"><img style="left: 0;" src="../../assets/buycar/checked.png"></div>
          </div>

        </div>

        <div class="btn-submit"><van-button color="#FF3939" :loading="loading" @click.stop="goPay">立即支付</van-button></div>
      </div>

    </div>
    <!-- 支付对话框 -->
    <van-overlay :show="showPay" z-index="5">
      <div class="paydalog">
        <img class="logo" :src="payWay == 'alipay' ? require('../../assets/buycar/alipaylogo1.png') : require('../../assets/buycar/wxpaylogo1.png')">
        <img class="right_content" :src="payWay == 'alipay' ? require('../../assets/buycar/alipayright.png') : require('../../assets/buycar/wxpayright.png')">
        <img :src="require('../../assets/buycar/alipayimg.png')">
        <div class="change-other-type" @click.stop="changeOtherType">
          <img :src="require('../../assets/buycar/back.png')">
          <span>选择其他支付方式</span>
        </div>
        <div id="payqr" />
        <!-- <div v-if="timeout > 0" class="timeout">支付倒计时：{{ getTimeOut() }}</div> -->
        <div class="tiptxt">
          <img :src="require('../../assets/buycar/scan.png')">
          <div class="txt">
            <span>请使用{{ payWay == 'alipay' ? '支付宝' : '微信' }}扫一扫</span>
            <span>扫描二维码支付</span>
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 支付成功 -->
    <pay-successed ref="paySuccessed" />
    <iFooter />
  </div>
</template>
<script>
import iHeader from '@/components/Header'
import iFooter from '@/components/Footer'
import iNav from '@/components/Nav'
import paySuccessed from './components/BrokerageCity/paySuccessed'

import { LinkTypeCode } from '../../dictionary/base.js'
import { BaseMixin } from '../../mixins/BaseMixin'
import QRCode from 'qrcodejs2'
let globalTimer = null
export default {
  name: 'SelectPay',
  components: { iHeader, iFooter, iNav, paySuccessed },
  mixins: [BaseMixin],
  data() {
    return {
      LinkTypeCode,
      payWay: 'alipay', // 支付方式(支付宝2，微信1付款等)
      last: true,
      loading: false,

      paying: false,
      showPay: false,
      OffTime: 9, // 9分钟计时
      OrderInfo: {
        OrderId: '',
        OrderNo: '',
        PayMoney: 0,
        PayInfo: {}
      },
      curIndex: null,
      employeeList: [],

      timeout: 0,
      timer: null,

      url: {
        queryPayState: '/api_pay/ExpenseApplications/GetSaleCouponOrderPayState',

        wxpay: '/api_pay/ExpenseApplications/SaleCouponsWechatPayQrCode',
        alipay: '/api_pay/ExpenseApplications/SaleCouponPayAlipayQrCode',
        // 到付

        getOrderPayInfo: '/api_pay/ExpenseApplications/GetOrderPayInfo'
      },
      orderOriginData: {
        dataSource: null,
        number: 0
      },
      payOrderInfo: {
        CouponMallOrderId: null, // 订单ID
        Price: null, // 订单价格
        CouponMallOrderNo: null, // 订单编号
        PayWay: null, // 支付方式
        OrderTime: '', // 生成订单的时间
        ResponseType: null, // 0.1.2
        Msg: null
      } // 订单详细数据
    }
  },
  destroyed() {
    clearInterval(this.timer)
    this.timeout = 0
    this.paying = false // 取消轮询
    clearTimeout(globalTimer)
  },
  created() {
    // const { OrderId, OrderNo, PayMoney, PayInfo } = this.$store.getters.ConfirmToPayData;
    // const mockData = { 'OrderId': 'ac429e0d-915e-4f86-a7e7-2067f6c19291', 'OrderNo': 'BL00120211130162511255520', 'PayMoney': 342.84, 'PayInfo': { 'OrderId': 'ac429e0d-915e-4f86-a7e7-2067f6c19291', 'TotalAmountPaidActual': 342.84, 'TotalAmountPaid': 0, 'GradedPayOneTimeAmount': 0, 'CustomerPayModeInfo': { 'IsAllowCashOnDeliveryInfo': false, 'IsAllowThirdPay': true, 'IsAllowGradePay': false, 'IsAllowBankTransfery': false, 'CompanyBankAccountInfo': null }, 'PayRecords': [], 'OffTime': 9.98796422 }}
    const { dataSource, number } = this.$route.params

    if (!dataSource || !number) {
      this.$toast({ position: 'bottom', message: '订单数据异常' })
      this.goBackMainPage()
      return
    } else {
      this.orderOriginData = { dataSource, number }
      this.createOrder()
    }
  },
  mounted() {
  },
  methods: {
    // 回到商城首页
    goBackMainPage() {
      this.$router.push(
        {
          name: 'BrokerageCity'
        }
      )
    },
    // 支付创建订单
    async createOrder() {
      // 清空之前的订单数据
      this.payOrderInfo = null
      this.loading = true
      this.$hys.openLoading()
      const res = await this.postAction('/api_coupon/CouponMall/ConfirmOrder', {
        From: 2, // 商城类型业务端
        Id: this.orderOriginData.dataSource.Id, // 券包ID
        SaleCouponsMgtId: this.orderOriginData.dataSource.SaleCouponsMgtId, // 券商城修改记录id
        PayWay: this.payWay === 'alipay' ? 2 : 1, // 支付方式
        Quantity: this.orderOriginData.number // 购买数量
      })
      // res = {
      //   CouponMallOrderId: 1,
      //   Price: 2,
      //   CouponMallOrderNo: 2,
      //   PayWay: 2,
      //   OrderTime: '2021-01-11',
      //   ResponseType: 1,
      //   Msg: '提示信息'
      // }
      if (res.IsSuccess && res.Data.ResponseType === 0) {
        this.payOrderInfo = res.Data
      }
      if (!res.IsSuccess) {
        this.$toast(res.Msg)
        setTimeout(() => {
          this.goBackMainPage()
        }, 1000)
      }
      if (res.Data.ResponseType === 1) {
        this.$dialog.alert('刷新', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.createOrder()
        })

        this.$hys.clearLoading()
      }
      if (res.Data.ResponseType === 2) {
        this.$hys.clearLoading()
        this.$toast(res.Data.Msg)
      }
      this.$hys.clearLoading()
      this.loading = false
    },
    // 更改支付方式
    onChangePayWay(payway) {
      this.payWay = payway
      this.createOrder()
    },
    async loadPayInfo() {
      const _this = this
      _this.$hys.openLoading()
      _this.loading = true
      try {
        const payInfo = await _this.getAction(_this.url.getOrderPayInfo, { id: _this.payOrderInfo.CouponMallOrderId, no: _this.payOrderInfo.CouponMallOrderNo })
        if (payInfo && payInfo.IsSuccess) {
          // 没支付  重新生成一个订单
          this.createOrder()
        } else {
          if (payInfo.Msg.indexOf('订单已支付完成') > -1) {
            return false
          }
        }
        return true
      } catch (err) {
        this.$toast({ position: 'bottom', message: err })
      } finally {
        _this.loading = false
        _this.$hys.clearLoading()
      }
    },
    // 支付
    async goPay() {
      const _this = this
      if (!_this.payWay) {
        _this.$toast({ position: 'bottom', message: '请选择支付方式' })
        return
      }
      const para = {
        saleCouponsOrderId: _this.payOrderInfo.CouponMallOrderId,
        sourceType: 2
      }
      _this.showPay = true
      if (!para.saleCouponsOrderId || para.Amount <= 0) {
        _this.$toast({ position: 'bottom', message: '订单支付信息错误' })
        return
      }
      _this.$hys.openLoading()
      // 获取订单二维码地址
      const payRes = await _this.getAction(_this.url[_this.payWay], para)
      _this.$hys.clearLoading()
      if (!payRes.IsSuccess) {
        _this.loading = false
        _this.$toast({ position: 'bottom', message: payRes.Msg })
        return
      }
      // 前端展示支付二维码信息
      this.$nextTick(() => {
        _this.createQrcode(_this.payWay, payRes.Data.codeUrl)
      })

      globalTimer = setTimeout(() => {
        // 打开支付弹窗后,需要轮询支付结果
        const getData = { saleCouponsOrderId: para.saleCouponsOrderId }
        this.paying = true
        this.goPayValidateSuccess(_this, getData, 0, 0)
        return true
      }, 5000)
    },

    createQrcode(payway, url) {
      document.getElementById('payqr').innerHTML = ''
      new QRCode('payqr', {
        width: 299,
        height: 299,
        text: url, // 二维码地址
        src: payway == 'alipay' ? require('../../assets/buycar/alipaylogo.png') : require('../../assets/buycar/wxpaylogo.png') // 二维码中间的图片
      })
      this.timeout = 600
      // this.timer = setInterval(() => {
      //   if (this.timeout > 0) {
      //     this.timeout--
      //     return
      //   } else {
      //     this.loading = false
      //   }
      //   clearInterval(this.timer)
      //   this.showPay = false
      // }, 1000)
    },

    /**
		 * 验证支付是否成功
		 */
    async goPayValidateSuccess(_this, para, timers, maxtimers = 10) {
      if (!this.paying) return
      const queryRes = await _this.getAction(_this.url.queryPayState, para)
      if (queryRes.IsSuccess && queryRes.Data == 2) {
        this.paying = false
        this.showPay = false
        // if (!rst) {
        await _this.goPaySuccess(_this)
        // } else {
        _this.$hys.clearLoading()
        // }
      } else if (queryRes.IsSuccess && queryRes.Data == 3) {
        // 跳转支付失败
        _this.$hys.clearLoading()
        _this.$toast(queryRes.Msg)
        // this.$router.push({ path: 'PayFail', params: _this.OrderInfo });
      } else if (maxtimers > 0 && timers > maxtimers) {
        // never reach
        _this.$toast('timeout')
      } else {
        setTimeout(() => {
          this.goPayValidateSuccess(_this, para, timers + 1, maxtimers)
        }, 3000)
      }
    },
    // 修改支付方式
    async changeOtherType() {
      this.showPay = false
      this.paying = false
      this.loading = false
      const queryRes = await this.getAction(this.url.queryPayState, { saleCouponsOrderId: this.payOrderInfo.CouponMallOrderId }) // 查看是否支付完成 重新加载支付数据
      if (queryRes.IsSuccess && queryRes.Data == 2) {
        // 支付完成
        await this.goPaySuccess(this)
      } else {
        clearInterval(this.timer)
        this.timeout = 0
        this.$hys.clearLoading()
      }
    },
    /**
		 * 跳转支付成功
		 */
    async goPaySuccess(_this) {
      // 获取随机商品信息

      _this.loading = false
      _this.$hys.clearLoading()
      this.$refs.paySuccessed.show()
    },
    // 支付遇到问题
    onClickRight() {
      this.$router.push(PayQuota)
      console.log(PayQuota)
    },
    getTimeOut() {
      const min = parseInt(this.timeout / 60)
      const sec = parseInt(this.timeout % 60)
      let tim = ''
      if (min > 0) {
        tim = `${tim}${min}分钟`
      }
      tim = `${tim}${sec}秒`
      return tim
    }
  }
}
</script>
<style lang="less">
.select-pay {
  background-color: #F3F5F7;

  a {
    color: #0F6EEA;
  }

  .orderInfo {
    display: flex;
    align-items: center;
    margin: 0 auto;
    margin-top: 30px;
    width: 1200px;
    height: 190px;
    background-color: #FFFFFF;
    box-sizing: border-box;

    img,
    .infotext {
      margin-left: 40px;
    }

    .infotext {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: calc(1200px - 127px);

      .info {
        text-align: left;

        .line1 {
          font-size: 26px;

          span {
            color: #0F6EEA;
          }
        }

        .line2 {
          margin-top: 10px;
          font-size: 14px;
          color: #777777;

          span {
            color: #FF3939;
          }
        }
      }

      .price {
        margin-right: 30px;
        font-size: 14px;
        color: #222222;

        span {
          font-size: 26px;
          color: #FF3939;
        }
      }
    }
  }

  .payInfo {
    display: flex;
    align-items: center;
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 80px;
    padding: 40px 35px 120px 40px;
    width: 1200px;
    background-color: #FFFFFF;
    flex-direction: column;
    box-sizing: border-box;

    .line {
      margin-top: 20px;
      width: 100%;
      height: 1px;
      background-color: #E8E8E8;
    }

    .tip {
      display: flex;
      justify-content: space-between;
      width: 100%;
      font-size: 16px;
      color: #777777;

      span {
        &:first-child {
          font-size: 16px;
          color: #777777;
        }

        &:last-child {
          float: right;
          font-size: 14px;
          color: #0F6EEA;
        }
      }
    }

    .three {
      display: flex;
      align-items: center;
      width: 100%;

      div {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 50px;
        border: 1px solid rgba(229, 229, 229, 1);
        border-radius: 2px;
        height: 80px;
        text-align: center;
        box-sizing: border-box;
        cursor: pointer;

        > img {
          position: absolute;
          left: 30px;
          height: 42px;
        }

        .check {
          display: none;
        }
      }

      .checked {
        position: relative;
        border: 3px solid rgba(15, 110, 234, 1);
        border-radius: 2px;
        box-shadow: 0 5px 14px 0 rgba(231, 231, 231, 1);

        .check {
          position: absolute;
          right: 0;
          bottom: 0;
          display: block;
          border: none;
          width: 39px;
          height: 39px;
        }
      }

      .alipay {
        width: 251px;
      }

      .wxpay {
        margin-left: 50px;
        width: 283px;
      }

      .firstpay {
        margin-left: 50px;
        width: 334px;
      }
    }

    .splitpay {
      margin-top: 50px;
      width: 100%;
      font-size: 20px;
      color: #222222;

      /deep/.van-radio-group {
        height: 28px;
      }

      /deep/.van-radio--horizontal {
        margin-right: 130px;
      }

      .banklist,
      .morebank {
        display: flex;
        padding: 0 0 20px 20px;
        width: 100%;
        font-size: 14px;
        background-color: #F8F8F8;
        box-sizing: border-box;
        flex-direction: column;
        cursor: pointer;

        .bankitm {
          display: flex;
          align-items: center;
          margin-top: 20px;

          .left {
            max-width: 22px;
            max-height: 22px;
            text-align: left;
          }

          .right {
            margin-left: 10px;
            color: #222222;
          }
        }
      }

      .morebank {
        font-size: 14px;
        text-align: left;
        color: rgba(15, 110, 234, 1);
      }
    }

    .banktip {
      display: flex;
      align-items: center;
      margin-top: 50px;
      padding-left: 20px;
      width: 100%;
      height: 50px;
      font-size: 14px;
      text-align: left;
      color: #E47D2F;
      background-color: #FFF7E9;
      box-sizing: border-box;

      i {
        margin-top: 3px;
        margin-right: 5px;
      }
    }

    .pay-split {
      display: flex;
      align-items: flex-start;
      margin-top: 30px;
      padding-top: 30px;
      padding-bottom: 56px;
      padding-left: 40px;
      background-color: #F8F8F8;
      box-sizing: border-box;
      flex-direction: column;

      .title {
        margin-bottom: 10px;
        font-size: 16px;
        color: #777777;
      }

      .pay-split-item {
        margin-top: 40px;
        text-align: left;

        > span {
          font-size: 20px;
          text-align: left;
          color: #C2C2C2;
        }

        .pay-split-item-m {
          display: flex;
          align-items: center;
          margin-top: 20px;

          button {
            margin-left: 97px;
            width: 258px;
            height: 80px;
            font-size: 26px;
            color: #FFFFFF;
            background-color: #FF3939;

            &:disabled {
              background-color: #D5D5D5;
            }
          }

          .psimpd,
          .psimp {
            border-radius: 4px;
            padding-left: 30px;
            width: 410px;
            height: 80px;
            font-size: 32px;
            color: #777777;
            background-color: #F1F1F1;
            line-height: 80px;
            box-sizing: border-box;
          }
        }
      }
    }

    .bank {
      width: 100%;

      .banktype {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 50px;
        border: 1px solid rgba(229, 229, 229, 1);
        border-radius: 2px;
        width: 296px;
        height: 80px;
        text-align: center;
        box-sizing: border-box;

        img {
          height: 44px;
        }
      }

      .bankinfo {
        display: flex;
        margin-top: 30px;
        padding: 0 0 20px 20px;
        width: 100%;
        font-size: 14px;
        background-color: #F8F8F8;
        box-sizing: border-box;
        flex-direction: column;

        .infoitm {
          display: flex;
          align-items: center;
          margin-top: 20px;

          .left {
            width: 60px;
            text-align: left;
            color: #444444;
          }

          .right {
            margin-left: 50px;
            color: #777777;
          }
        }
      }
    }

    .btn-submit {
      margin-top: 44px;
      width: 100%;
      text-align: left;

      button {
        width: 258px;
        height: 80px;
        font-size: 26px;
      }
    }
  }

  .paydalog {
    position: relative;
    margin: 0 auto;
    margin-top: 150px;
    width: 1200px;
    height: 650px;

    .change-other-type {
      position: absolute;
      bottom: 24px;
      left: 42px;
      display: flex;
      align-items: center;
      width: 140px;
      height: 26px;
      cursor: pointer;

      > span {
        margin-left: 15px;
        font-size: 14px;
        color: #0F6EE9;
      }
    }

    .timeout {
      position: absolute;
      top: 120px;
      left: 201px;
      width: 299px;
      height: 30px;
      font-size: 16px;
      text-align: center;
      color: #FF3939;
      line-height: 30px;
    }

    .tiptxt {
      position: absolute;
      top: 486px;
      left: 205px;
      display: flex;
      align-items: center;
      width: 300px;
      height: 63px;
      background-color: #70AAF4;

      > img {
        margin-left: 17px;
      }

      .txt {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-left: 14px;
        font-size: 14px;
        color: #FFFFFF;
        flex-direction: column;
      }
    }

    .logo {
      position: absolute;
      top: 37px;
      left: 30px;
    }

    .right_content {
      position: absolute;
      top: 113px;
      left: 656px;
    }

    #payqr {
      position: absolute;
      top: 166px;
      left: 205px;
      width: 299px;
      height: 299px;
    }
  }

  .carName {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;

    .cn {
      display: flex;
      align-items: flex-end;
      height: 100%;
    }
  }
}
</style>
